module.exports = __webpack_public_path__ + "img/histoire.b899e888.png";